module.exports = __webpack_public_path__ + "static/media/logoBile.543c74fe.png";